import {appUrl} from '@hconnect/common/hproduce/config'
import {COCKPIT_HOST} from '@hconnect/common/hproduce/config/cockpit'
import {TASKS_SEGMENT} from '@hconnect/common/hproduce/consts'
import {DateRange, ShiftQuickSelectSlots} from '@hconnect/common/types'
import {generateQueryString, getTimeRangeOrQuickSelectSlotsString} from '@hconnect/common/utils'
import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {SxProps, Theme} from '@mui/material'
import {ShiftTasksSummaryContainer} from '@widgets/shift-tasks'
import {generatePath} from 'react-router'

import {useOptimizationSpecialistTimeRange} from '../hooks'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

const generateCockpitShiftTasksLink = (
  timeRange: DateRange | ShiftQuickSelectSlots,
  plantId: string
): string => {
  const query = {
    timeRange: getTimeRangeOrQuickSelectSlotsString(timeRange)
  }

  // TODO: extract all external app link generation to a separate file
  const baseUrl = appUrl(COCKPIT_HOST)
  const path = generatePath(`/:plantId/${TASKS_SEGMENT}`, {plantId})
  const endpoint = `${baseUrl}${path}`
  const linkPath = `${endpoint}?${generateQueryString(query)}`

  return linkPath
}

export const ShiftTasksContainer: React.FC<Props> = ({
  plantId,
  cardBoxSx,
  placeholderWrapperSx
}) => {
  const {start, end, rawTimeRange} = useOptimizationSpecialistTimeRange(plantId)

  const linkPath = generateCockpitShiftTasksLink(rawTimeRange, plantId)

  return (
    <CardLinkWrapper href={linkPath} data-test-id="shift-tasks-summary-card-link-to-shiftReport">
      <ShiftTasksSummaryContainer
        plantId={plantId}
        from={start}
        to={end}
        cardBoxSx={cardBoxSx}
        placeholderWrapperSx={placeholderWrapperSx}
      />
    </CardLinkWrapper>
  )
}
